/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import back$1 from './web/index.js';
import back$2 from './dingTalk/index.js';
import back$3 from './tb/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../navigate-back/index.js';
import '../../index-e5fa4dec.js';
import '../navigate-back/cn/index.js';
import '../navigate-back/cnStation/index.js';
import '../navigate-back/fm/index.js';
import '../../common-42e7d8d8.js';
import '../../safe-data-66f20265.js';
import '../navigate-back/tm/index.js';
import '../navigate-back/tb/index.js';
import '../navigate-back/ali1688/index.js';
import '../navigate-back/browser/index.js';
import '../navigate-back/dingTalk/index.js';
import '../navigate-back/dingTalkPC/index.js';
import '../navigate-back/panguMiniApp/index.js';
import '../navigate-back/mini/index.js';
import '../../index-ee2c9aee.js';
import '../../tool-7a8f4749.js';

var baseBack = extend({
    web: back$1,
});
// api: https://uni-apis.alibaba-inc.com/doc/Navigation/back
// 原则：native原生有的，用原生能力；没有则用前端js hack兜底
var apiConfig = {
    web: {
        dingTalk: back$2,
        windvane: {
            tb: back$3,
        },
        panguMiniApp: back$1,
    },
};
/**
 * 若当前 WebView 有 history，则后退，否则关闭当前 WebView。
 * 方案：淘宝、钉钉端有原生Native，则端支持；其他端使用js hack处理，优先history.back()，未变动路由则走navigateBack()。
 * 详见RFC: https://alidocs.dingtalk.com/i/nodes/qXomz1wAyjKVXoALob7lW3Y9pRBx5OrE# 「【新增back API】支持回退上个页面」
 * @see API：https://yuque.antfin.com/cn-xt/arch/lwbvd0#4e081fc0
 * @returns {Promise<unknown>} promise调用结果
 * @example 使用案例：
 * import { back } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * back()
 *   .then(() => {
 *     console.log('success');
 *   })
 *   .catch((error) => {
 *     console.log(error);
 *   });
 * @author 敬文
 */
var back = extend(apiConfig, baseBack);

export { back };
